import React from 'react';
import { Box } from '@chakra-ui/react';

import ImgWave from '@/components/Common/Wave/assets/wave-v4.svg';

import { SLIDE_1, SLIDE_2, SLIDE_3, SLIDE_4, SLIDE_5 } from '@/constants/assets';

import './styles.css';

function ImagesFade() {
  return (
    <Box width="100%" zIndex="1" transform="translateY(200)">
      <div className="slide">
        <Box backgroundImage={`url(${SLIDE_1})`} />
        <Box backgroundImage={`url(${SLIDE_2})`} />
        <Box backgroundImage={`url(${SLIDE_3})`} />
        <Box backgroundImage={`url(${SLIDE_4})`} />
        <Box backgroundImage={`url(${SLIDE_5})`} />
      </div>
      <Box
        backgroundImage={`url(${ImgWave})`}
        width="100%"
        height="40px"
        transform="translateY(-38px)"
        zIndex="9999"
      />
    </Box>
  );
}

export default ImagesFade;
